module.exports = __webpack_public_path__ + "img/talicska.32c39a63.svg";